import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=b27074fe&"
import script from "./TwoFactor.vue?vue&type=script&lang=js&"
export * from "./TwoFactor.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports